<template>
    <edit-validation-plan-template-component 
        :currentGuideline="currentGuideline"
        :assesmentMethods="assesmentMethods"
        :guidelines="guidelines"
        :validationParameters="validationParameters"
        :currentValidationPlanTemplate="currentValidationPlanTemplate"
        @submitArchivedTemplate="handleSubmitArchivedTemplate"
        @submitEditedTemplate="handleSubmitEditedTemplate"
        @back="handleBack">
    </edit-validation-plan-template-component>
</template>

<script>
import EditValidationPlanTemplateComponent from '@/components/template/EditValidationPlanTemplateComponent'
import axios from "axios";
import { mapGetters, mapMutations } from 'vuex'
import MetadataParser from "@/valchrom/MetadataParser";

export default {
    name: 'EditValidationPlanTemplate',
    components: {EditValidationPlanTemplateComponent},
    data: function () {
        return {
            component_url: 'experiments/templates/',
            currentValidationPlanTemplate: [],
            assesmentMethods:[],
            currentGuideline:{},
            guidelines:{}
        }
    },

    computed: {
        ...mapGetters ([
            'base_url', 'currentValidationPlanTemplateID', 'auth_header', 'validationParameters'
        ]),        
        
    },
    
    mounted: function() {
        this.setBreadcrumb()
        if (this.$route.params.id) {
            this.currentValidationPlanTemplate.id = this.$route.params.id
            this.setValidationPlanTemplateID()
        }
        else {
            console.log("OpenValidationPlanTemplate view no router params.id")
            this.currentValidationPlanTemplate.id = this.currentValidationPlanTemplateID
        } 
        this.getValidationPlanTemplate()
    },


    methods: {
        ...mapMutations([
            'SET_BREADCRUMB', 'CHANGE_VALIDATION_PLAN_TEMPLATE_ID'
        ]),
        setBreadcrumb: function(){
            this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
        },
        setValidationPlanTemplateID: function() {
            this.CHANGE_VALIDATION_PLAN_TEMPLATE_ID(this.currentValidationPlanTemplate.id)
        },
        handleBack: function(currentValidationPlanTemplate) {
            this.$router.push({ name: "ValidationPlanTemplates", params: {id: currentValidationPlanTemplate.id} });
        },
        getGuidlines: function(){ 
            axios
                .get(
                    this.base_url+"experiments/guidelines",
                    {
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    //TODO: hotfix - hide ROB, RUG and SST
                    response.data.forEach(function(item) {
                        item.assessment_methods = item.assessment_methods.filter(
                            (am) => {
                                return !(
                                    am.code_name.startsWith("ROB:") ||
                                    am.code_name.startsWith("RUG:") ||
                                    am.code_name.startsWith("SST:")
                                )
                            }
                        )
                    });

                    this.guidelines = response.data;
                    var mainThis = this                 
                    response.data.forEach(function(item) {
                        if(item.name == mainThis.currentValidationPlanTemplate.guideline){
                            mainThis.currentGuideline = item;
                        }
                    })   
                    console.log("this.currentGuideline: ", this.currentGuideline)
                    console.log("this.guidelines: ", this.guidelines)
                })
                .catch(error => {
                    console.log("Something went wrong getting guidlines", error);
                });
                
        },
        getValidationPlanTemplate: function(){ 
            axios
                .get(
                    this.base_url+this.component_url +
                    this.currentValidationPlanTemplate.id,
                    {
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    this.currentValidationPlanTemplate = response.data;
                    if(this.currentValidationPlanTemplate.status == 'LOCKED') {
                        this.loading = false;
                        this.$toast.open({
                            duration: 5000,
                            message: `Validation Plan, ${response.data.name}, is locked and cannot be edited.`,
                            position: 'is-top',
                            type: 'is-danger'
                        })
                        this.$router.push({ name: "ValidationPlanTemplates", params: {  } });
                    } else{
                        console.log("Current ValidationPlanTemplate edit: ", response.data)
                        this.getGuidlines()
                    }
                    
                
                })
                .catch(error => {
                    console.log("Something went wrong getting the current ValidationPlanTemplate", error);
                });
                
        },
        getAssesmentMethod: function(method, currentValidationPlanTemplate){
            axios
                .get(
                    this.base_url+ "experiments/assessments/"  +
                    method,
                    {
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    var meth = response.data
                    meth.criteria = []
                    // loop criteria and add to the method
                    currentValidationPlanTemplate.criteria.forEach(function(item) {
                        if(item.assessment_method==method){
                            meth.criteria.push(item)
                        }
                    })
                    // Add assMeth to the array
                    // console.log("assesmentMethods structure", meth)
                    // Sort Criteria
                    meth.criteria.sort(function(a, b) {
                        var nameA = a.name.toUpperCase(); // ignore upper and lowercase
                        var nameB = b.name.toUpperCase(); // ignore upper and lowercase
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        
                        // names must be equal
                        return 0;
                    });
                    this.assesmentMethods.push(meth)

                    this.assesmentMethods.sort(function(a, b) {
                        var nameA = a.name.toUpperCase(); // ignore upper and lowercase
                        var nameB = b.name.toUpperCase(); // ignore upper and lowercase
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        
                        // names must be equal
                        return 0;
                    });
                    
                })
                .catch(error => {
                    console.log("Something went wrong getting the current ass meth", error);
                });
        },

        handleSubmitArchivedTemplate: function(archivedTemplate) {
            axios
                .patch(`${this.base_url}${this.component_url}${archivedTemplate.id}/archive/`,
                    {},
                    { 
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    console.log("Validation Plan Successfully Archived:", archivedTemplate);
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Validation Plan Successfully Archived`,
                        position: 'is-top',
                        type: 'is-primary'
                    })
                    this.$router.push({ name: "ValidationPlanTemplates", params: {  } });
                })
                .catch(error => {
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Validation Plan was not successfully Archived`,
                        position: 'is-top',
                        type: 'is-danger'
                    })
                    console.log("Validation Plan was not successfully Archived: ", error.response.data);
                });
        },
        handleSubmitEditedTemplate: function(editedTemplate) {
            console.log('handle edit: ----------- ', JSON.stringify(editedTemplate.am_metadatas) )
            axios
                .patch(`${this.base_url}${this.component_url}${editedTemplate.id}`,
                    editedTemplate,
                    { 
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    console.log("Validation Plan Successfully Updated:", editedTemplate);
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Validation Plan Successfully Updated`,
                        position: 'is-top',
                        type: 'is-primary'
                    })
                    this.$router.push({ name: "ValidationPlanTemplates", params: {  } });
                })
                .catch(error => {
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Validation Plan was not successfully Updated`,
                        position: 'is-top',
                        type: 'is-danger'
                    })
                    console.log("Validation Plan was not successfully Updated: ", error.response.data);
                });
        }        
    },

}
</script>

